const isEuropeanCountry = require('../isEuropeanCountry')
const {
  DEFAULT_VAT_RATES_PER_COUNTRY,
  VAT_RATES_PER_COUNTRY,
  VAT_RATES_REVERSE_CHARGED,
  VAT_IS_NOT_SUPPORTED_IN_COUNTRY_CODES
} = require('../../../shared/constants')

const getDefaultVatRateForCountry = (country, rates = DEFAULT_VAT_RATES_PER_COUNTRY) =>
  rates[country] || 0

const getVatRatesForCountry = (teamCountry) => VAT_RATES_PER_COUNTRY[teamCountry]

function getVatLevels (
  teamCountry,
  contactAddressCountry = null,
  vatNumber = null
) {
  if (
    contactAddressCountry &&
    isReverseCharged(teamCountry, contactAddressCountry, vatNumber)
  ) {
    return VAT_RATES_REVERSE_CHARGED
  }

  return VAT_RATES_PER_COUNTRY[teamCountry]
}

// Because of inconsistencies in our application sometimes the
// contactAddressCountry can be GB while we are expecting it to be UK
const getCorrectCountryCode = (country) => country === 'GB' ? 'UK' : country

/*
 When an invoice is created and is send from a European country to ANOTHER European country,
 The VAT should be 'reverse charged'. This should only happen when VAT Number is present though.
 */
function isReverseCharged (teamCountry, contactAddressCountry, vatNumber) {
  contactAddressCountry = getCorrectCountryCode(contactAddressCountry)

  const teamIsEuropean = isEuropeanCountry(teamCountry)
  const contactAddressIsEuropean = isEuropeanCountry(contactAddressCountry)

  if (!teamIsEuropean || !contactAddressIsEuropean) {
    return false
  }

  if (teamCountry === contactAddressCountry) {
    return false
  }

  const missingVatNumber =
    !vatNumber || typeof vatNumber !== 'string' || !vatNumber.trim()

  return !missingVatNumber
}

function getDefaultVatRateForTeam (teamCountry, teamVatRate) {
  if (isVatSupportedInCountry(teamCountry) && teamVatRate) {
    return teamVatRate
  }
  return 0
}

const isVatSupportedInCountry = country => !VAT_IS_NOT_SUPPORTED_IN_COUNTRY_CODES.includes(country)

function getVatRate (teamCountry, contactCountry, teamVatRate, contactVatNumber) {
  contactCountry = getCorrectCountryCode(contactCountry)
  const isTeamCountryEqualContactCountry = teamCountry === contactCountry
  const shouldBeReverseCharged = isReverseCharged(teamCountry, contactCountry, contactVatNumber)
  const isContactCountryNonEU = (contactCountry && !isEuropeanCountry(contactCountry))

  if (isTeamCountryEqualContactCountry) {
    return teamVatRate
  }

  if (shouldBeReverseCharged) {
    return 0
  }

  if (isContactCountryNonEU) {
    return 0
  }

  return teamVatRate
}

module.exports = {
  isReverseCharged,
  getVatLevels,
  getDefaultVatRateForCountry,
  getVatRatesForCountry,
  getDefaultVatRateForTeam,
  getVatRate,
  isVatSupportedInCountry
}
